import {Tooltip} from 'platform/components';

import {useId} from 'react';

import {BLUE_60, FG_PRIMARY, FG_TERTIARY, NEUTRAL_20, SWITCH_OFF, ELEV_1} from '../../constants';

const DISABLED_OPACITY = 0.5;

export function SettingToggle(props: {
  label: string;
  hint: string;
  value: boolean;
  onChange: (value: boolean) => void;
  isFirst?: boolean;
  isDisabled?: boolean;
  disabledTooltip?: string;
}) {
  const disabledDescriptionId = useId();

  return (
    <Tooltip
      label={props.isDisabled ? props.disabledTooltip : undefined}
      shouldWrapperStretch
      placement="top"
    >
      <button
        type="button"
        role="switch"
        aria-checked={props.value}
        aria-label={props.label}
        aria-describedby={props.isDisabled ? disabledDescriptionId : undefined}
        disabled={props.isDisabled}
        onClick={() => props.onChange(!props.value)}
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: '14px',
          width: '100%',
          padding: '11px 0',
          border: 0,
          borderTop: props.isFirst ? 'none' : `1px solid ${NEUTRAL_20}`,
          background: 'transparent',
          textAlign: 'left',
          cursor: props.isDisabled ? 'not-allowed' : 'pointer',
          opacity: props.isDisabled ? DISABLED_OPACITY : 1,
        }}
      >
        <span style={{display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0}}>
          <span style={{fontSize: '13px', fontWeight: 500, color: FG_PRIMARY}}>{props.label}</span>
          <span style={{fontSize: '12px', color: FG_TERTIARY, lineHeight: 1.4}}>{props.hint}</span>
        </span>
        <span
          style={{
            width: '40px',
            height: '22px',
            borderRadius: '9999px',
            background: props.value ? BLUE_60 : SWITCH_OFF,
            flexShrink: 0,
            position: 'relative',
            marginTop: '1px',
            transition: 'background 160ms',
          }}
        >
          <span
            style={{
              position: 'absolute',
              top: '2px',
              left: '2px',
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              background: '#FFFFFF',
              boxShadow: ELEV_1,
              transform: props.value ? 'translateX(18px)' : 'translateX(0)',
              transition: 'transform 160ms',
            }}
          />
        </span>
      </button>
      <span id={disabledDescriptionId} className="sr-only">
        {props.disabledTooltip}
      </span>
    </Tooltip>
  );
}
